window.StatisticsCard = (target = 0) => {
	return {
		target: Number(target) || 0,
		display: '0',
		duration: 3000, // ~3 seconds

		// Match the number of decimal places of the target so e.g. 12.5 counts
		// up as 0.0 → 12.5 and 1000 counts up as whole numbers.
		get decimals() {
			return (String(this.target).split('.')[1] || '').length;
		},

		format(value) {
			return value.toLocaleString(undefined, {
				minimumFractionDigits: this.decimals,
				maximumFractionDigits: this.decimals,
			});
		},

		// Called by x-intersect.once when the stat scrolls into view.
		start() {
			// Respect users who prefer reduced motion: show the final value.
			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				this.display = this.format(this.target);
				return;
			}

			const startTime = performance.now();

			const tick = (now) => {
				const progress = Math.min((now - startTime) / this.duration, 1);
				// easeOutCubic for a natural decelerating count.
				const eased = 1 - Math.pow(1 - progress, 3);
				this.display = this.format(this.target * eased);

				if (progress < 1) {
					requestAnimationFrame(tick);
				} else {
					this.display = this.format(this.target);
				}
			};

			requestAnimationFrame(tick);
		},
	};
};
